<template>
    <div class="spinning-car" :style="{ maxWidth: width, marginTop: marginTop}">
        <svg  viewBox="0 0 680 260" role="img" xmlns="http://www.w3.org/2000/svg">

        <circle cx="340" cy="130" r="60" fill="none" stroke="#6899f5" stroke-width="6" stroke-opacity="0.15"/>

        <g class="spinner-group">
            <path d="M 340 70 A 60 60 0 1 1 339.99 70" fill="none" stroke="#6899f5" stroke-width="6" stroke-linecap="round" stroke-dasharray="80 300" stroke-dashoffset="0"/>

            <g transform="rotate(76, 340, 130) translate(340, 70) scale(-1,1)">
            <rect x="-24" y="-8" width="48" height="16" rx="4" fill="#6899f5"/>
            <path d="M -10,-8 Q -4,-20 8,-20 L 20,-20 Q 26,-20 26,-8 Z" fill="#4a7de8"/>
            <path d="M -8,-8 Q -3,-18 8,-18 L 19,-18 Q 24,-18 24,-8 Z" fill="#a8c4fb"/>
            <rect x="22" y="-6" width="8" height="5" rx="1" fill="#ffd166"/>
            <rect x="-28" y="-5" width="6" height="4" rx="1" fill="#ff6b6b"/>
            <line x1="-10" y1="-8" x2="-10" y2="0" stroke="#3a6ad4" stroke-width="1"/>
            <circle cx="-14" cy="8" r="7" fill="#1a1a2e"/>
            <circle cx="-14" cy="8" r="2.5" fill="#8ab0f8"/>
            <circle cx="18" cy="8" r="7" fill="#1a1a2e"/>
            <circle cx="18" cy="8" r="2.5" fill="#8ab0f8"/>
            </g>
        </g>

        </svg>
    </div>
</template>
<script>
export default {
    props: {
        width: {
            type: String,
            default: "600px"
        },
        marginTop: {
            type: String,
            default: "0"
        }
    }
}
</script>
<style scoped>
    div.spinning-car{
        margin: auto;
        max-width: 100%;
    }

    @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
    }
    .spinner-group {
        transform-origin: 340px 130px;
        animation: spin 2s linear infinite;
    }
</style>